<template>
    <div>

        <div class="row">
            <div class="col-12 col-lg-10 mt-3 my-lg-0 px-0 mx-auto">
                <div class="row g-0 justify-content-evenly justify-content-sm-center align-items-center">
                    <div class="col-auto">
                        <a @click="searchType = ''"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == ''
                            }" tabindex="0" href="javascript:void(0);">
                            TUTTO
                        </a>
                    </div>
                    <div class="col-auto">
                        <a @click="searchType = 'ILO'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'ILO'
                            }" tabindex="0" href="javascript:void(0);">ESERCIZI INTERATTIVI</a>
                    </div>
                    <div class="col-auto">
                        <a @click="searchType = 'TLO'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'TLO'
                            }" tabindex="0" href="javascript:void(0);">SCHEDE</a>
                    </div>
                    <div class="col-auto">
                        <a  @click="searchType = 'PA'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'PA'
                            }" tabindex="0" href="javascript:void(0);">PERCORSI</a>
                    </div>
                    <div class="col-auto">
                        <a  @click="searchType = 'RECENTI'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'RECENTI'
                            }">RECENTI</a>
                    </div>
                    <div class="col-auto">
                        <a  @click="searchType = 'PREFERITI'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'PREFERITI'
                            }">PREFERITI</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row flex-xl-nowrap mt-5">
            <div class="col-xl-2 filters-container">
                <div class="row">
                    <div class="col-lg-12">
                        <div v-if="countActivityFacetes > 0" class="col-12 mb-5">
                            <h5>Attività</h5>

                            <ul v-if="!searchFacet.activity_str">
                                <li v-for="(option, ok) in activityFacets" :key="ok" class="my-2">
                                    <p class="cursor-pointer"
                                        @click="onClickAddFacet('activity_str', ok)">
                                        {{ok}}
                                        <span class="badge bg-secondary">
                                           {{option}}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                            <div v-else>
                                <p class="cursor-pointer"
                                    @click="onClickRemoveFacet('activity_str')">
                                    <i class="bi bi-trash"></i>
                                    {{searchFacet.activity_str}}
                                </p>

                                <div class="my-3">
                                    <h5 v-if="countAbilityFacetes > 0" class="my-2">Abilità</h5>
                                    <ul v-if="!searchFacet.ability_str">
                                        <li v-for="(option, ok) in abilityFacets" :key="ok" class="my-2">
                                            <p class="cursor-pointer"
                                                @click="onClickAddFacet('ability_str', ok)">
                                                {{ok}} 
                                                <span class="badge bg-secondary">
                                                    {{option}}
                                                </span>
                                            </p>
                                        </li>
                                    </ul>
                                    <div v-else >
                                        <p class="cursor-pointer margin-bottom" href="javascript:void(0);"
                                            @click="onClickRemoveFacet('ability_str')">
                                            <i class="bi bi-trash"></i>
                                            {{searchFacet.ability_str}}
                                        </p>

                                        <div class="my-3">
                                            <h5 v-if="countProcessFacetes > 0" class="my-2">Processo</h5>
                                            <ul v-if="!searchFacet.process_str">
                                                <li v-for="(option, ok) in processFacets" :key="ok" class="my-2">
                                                    <p class="cursor-pointer"
                                                        @click="onClickAddFacet('process_str', ok)">
                                                        {{ok}} 
                                                        <span class="badge bg-secondary">
                                                            {{option}}
                                                        </span>
                                                    </p>
                                                </li>
                                            </ul>
                                            <div v-else>
                                                <p class="cursor-pointer margin-bottom"
                                                    @click="onClickRemoveFacet('process_str')">
                                                    <i class="bi bi-trash"></i>
                                                    {{searchFacet.process_str}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="gradeFacets.length > 0" class="col-12 mb-5">
                            <h5>Classe</h5>

                            <ul v-if="!searchFacet.grade_str">
                                <li v-for="(option, ok) in gradeFacets" :key="ok" class="my-2">
                                    <p @click="onClickAddFacet('grade_str', option.key)"
                                        class="cursor-pointer">
                                        {{ option.label }}
                                        <span class="badge bg-secondary">
                                            {{option.count}}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                            <div v-else>
                                <p class="cursor-pointer margin-bottom"
                                    @click="onClickRemoveFacet('grade_str')">
                                    <i class="bi bi-trash"></i>
                                    {{ results.grades[searchFacet.grade_str ]}}
                                </p>
                            </div>
                        </div>

                        <div v-if="paTypesFacets.length > 0" class="col-12 mb-5">
                            <h5>Tipo percorso</h5>

                            <ul v-if="!searchFacet.pa_type">
                                <li v-for="(option, ok) in paTypesFacets" :key="ok" class="my-2">
                                    <p @click="onClickAddFacet('pa_type', option.key)" 
                                        class="cursor-pointer">
                                        {{ option.label }}
                                        <span class="badge bg-secondary">
                                            {{option.count}}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                            <div v-else>
                                <p class="cursor-pointer margin-bottom" @click="onClickRemoveFacet('pa_type')">
                                    <i class="bi bi-trash"></i>
                                    {{ results.pa_type == 'public' ? 'Erickson' : 'Personali' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-10">
                <div class="col-9 col-lg-6 mx-auto" v-if="searchType != 'RECENTI' && searchType != 'TOOL' && searchType != 'PREFERITI'">
                    <form @submit.prevent="onClickSearch()" class="erk form" action="#" method="post">
                        <div class="input-group">
                            <input :value="searchText" 
                                @input="searchText = $event.target.value"   
                                type="text" class="form-control" placeholder="" aria-label="" aria-describedby="button-addon1">
                            <button @click="onClickSearch()" class="btn btn-primary" type="button" id="button-addon1"><i class="bi bi-search pr-1"></i> <span class="d-none d-lg-inline-block">Cerca</span></button>
                        </div>
                    </form>
                </div>

                    <div class="row">
                        <div class="col-lg-10 mx-auto my-4 my-lg-1">

                        <div class="d-flex mb-4 justify-content-center">
                            <div class="me-5 pt-2">
                                <strong class="">Esercizi disponibili: {{results ? results.total : 0}}</strong>
                            </div>
                            <MbContentFindPaginator
                                :numElements="results.total"
                                :rowPerPage="rowPerPage"
                                v-model="currentPage">
                            </MbContentFindPaginator>
                        </div>

                        <!-- Ciclo loop attività -->
                        <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="course-pills-tab-1">    
                            <div class="row g-4">
                                <div
                                    v-for="(content, ck) in results.contents" :key="ck" 
                                    class="col-sm-6 col-lg-4 col-xl-3">
                                    <div class="card shadow h-100">
                                        <!-- Copertina -->
                                        <img v-if="content.type == 'PA' && content.pa_type == 'private'" src="/assets/img/percorso-custom.png" class="card-img-top py-2" alt="titolo LO">
                                        <img v-else :src="content.thumbnail" class="card-img-top py-2" alt="titolo LO">
                                        <!-- Card body -->
                                        <div class="card-body pb-3">
                                            <!-- Tag and preferito -->
                                            <div class="d-flex justify-content-between mb-1">
                                                <div class="badge color-materia text-decoration-none">
                                                    {{ content.actvity != null ? content.actvity : ' ' }}
                                                </div>
                                                <div>
                                                    {{ content.is_favorit }}
                                                    <a @click="onClickFavorite(content)" class="h6 mb-0">
                                                        <i v-if="content.is_favorite" class="bi bi-heart-fill"></i>
                                                        <i v-else class="bi bi-heart"></i>
                                                    </a>

                                                    <a 
                                                        v-if="content.type != 'PA'"
                                                        @click="onClickInfo(content)" class="h6 mb-0">
                                                        <i class="bi bi-info-circle"></i>
                                                    </a>

                                                    <a 
                                                        v-if="content.type != 'PA'"
                                                        @click="onClickAddToPath(content)" 
                                                        class="h6 mb-0 ms-2">
                                                        <i class="bi bi-plus-circle"></i>
                                                    </a>

                                                    <a 
                                                        v-if="content.type == 'PA' && content.pa_type == 'private'"
                                                        @click="onClickRemovePath(content)" 
                                                        class="h6 mb-0 ms-2">
                                                        <i class="bi bi-trash"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <hr class="mt-0 mb-0">
                                            <!-- Titolo -->
                                            <h5 class="card-title fs-5 mt-3">{{ content.name }}</h5>
                                            <p class="mb-2 text-truncate-2 pt-1 pb-3">{{ content.goal }}</p>

                                            <span v-if="content.is_new" class="badge bg-success">Novità</span>

                                            <div v-if="content.data_scadenza" class="">
                                                Disponibile fino al {{ content.data_scadenza | date }}
                                            </div>
                                        </div>
                                        <!-- Card footer -->
                                        <div class="card-footer pb-3">
                                            <div class="d-flex justify-content-between">
                                                <span v-if="content.numero_videate" class="h6 fw-light mb-0"><i class="bi bi-window-fullscreen text-danger me-2"></i>
                                                    {{ content.numero_videate }} Videate</span>
                                                <span v-if="content.tempo_stimato" class="h6 fw-light mb-0"><i class="bi bi-clock text-danger me-2"></i>
                                                    {{ content.tempo_stimato }} min
                                                </span>
                                            </div>
                                            <div class="d-flex justify-content-between mt-2 gap-3">
                                                <button type="button" 
                                                    @click="onClickPlayContent(content)"
                                                    class="h6 fw-light btn btn-secondary btn-block">
                                                    <template v-if="content.type == 'PA'">
                                                        Vedi le attività
                                                    </template>
                                                    <template v-else>
                                                        Avvia
                                                    </template>
                                                </button>

                                                <button type="button" 
                                                    v-if="sessionId"
                                                    @click="onClickAddContentToSession(content)"
                                                    :class="{
                                                        'h6 fw-light btn btn-assegna btn-secondary btn-block': true,
                                                    }">
                                                    <span v-if="contentInSession.indexOf(content.content_id) == -1" class="testo">Assegna</span>
                                                    <span v-else class="icona"><i class="bi bi-check-lg"></i></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /Colonna destra - dati -->
                        
                        <div class="mt-4">
                            <MbContentFindPaginator
                                :numElements="results.total"
                                :rowPerPage="rowPerPage"
                                v-model="currentPage">
                            </MbContentFindPaginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer v-if="sessionId" class="fixed-footer fixed-bottom">
            <div class="mt-3 mx-3 mb-3">
                <div class="d-flex justify-content-between">
                    <span class="h5">{{ exerciseCount ? exerciseCount : 0 }} Esercizi</span>
                    
                    <span class="h5">Tempo totale: {{ estimatedTime ? estimatedTime : 0 }} min</span>
                    <a @click="$emit('percorso-completato')" class="btn btn-primary align-items-start">
                        Assegna esercizi
                    </a>
                </div>
            </div>
        </footer>

        <MbPathsModal
            ref="modalPaths"
        ></MbPathsModal>       

        <MbPathDetailsModal
            ref="modalPathDetails"
        ></MbPathDetailsModal>

        <MbContentInfoModal 
            ref="modalContentInfo">
        </MbContentInfoModal>
    </div>
</template>
<script>
import axios from "axios"
import MbPathsModal from './MbPathsModal'
import MbPathDetailsModal from "./MbPathDetailsModal"
import MbContentFindPaginator from "./MbContentFindPaginator"
import MbContentInfoModal from "./MbContentInfoModal.vue"

let contentWindow = null

export default{
    components: {
        MbPathsModal,
        MbPathDetailsModal,
        MbContentFindPaginator,
        MbContentInfoModal
    },
    props: {
        userid: Number,
        sessionId: Number
    },
    data(){
        return {
            exerciseCount: 0,
            estimatedTime: 0,
            searchType: '',
            searchText: '',
            searchFacet: {},
            results: {},
            rowPerPage: 20,
            currentPage: 0,
            isLoading: false,
            contentInSession: []
        }
    },
    computed: {
        countActivityFacetes(){
            return Object.keys(this.getFacetsGreatherThanZero('activity_str')).length
        },
        activityFacets(){
            return this.getFacetsGreatherThanZero('activity_str')
        },
        countAbilityFacetes(){
            return Object.keys(this.getFacetsGreatherThanZero('ability_str')).length
        },
        abilityFacets(){
            return this.getFacetsGreatherThanZero('ability_str')
        },
        countProcessFacetes(){
            return Object.keys(this.getFacetsGreatherThanZero('process_str')).length
        },
        processFacets(){
            return this.getFacetsGreatherThanZero('process_str')
        },
        gradeFacets(){
            let facets = this.getFacetsGreatherThanZero('grade_str')

            let res = []

            if (!this.results || !this.results.grades){
                return res
            }

            for(let k in this.results.grades){
                if (!facets[k]){
                    continue
                }
                res.push({
                    key: k,
                    label: this.results.grades[k],
                    count: facets[k]
                })
            }

            return res
        },
        paTypesFacets(){
            let facets = this.getFacetsGreatherThanZero('pa_type')

            let res = []
            for(let k in facets){
                res.push({
                    key: k,
                    label: k == 'public' ? 'Erickson' : 'Personali',
                    count: facets[k]
                })
            }

            return res
        }
    },
    watch: {
        currentPage(){
            this.updateSearch()
        },
        searchType(){
            window.$('.mobile-menu-item').removeClass('active')
            window.$('#menu-' + this.searchType).addClass('active')
            
            this.searchFacet = {}
            
            if (this.currentPage > 0){
                this.currentPage = 0
            } else if (this.searchText != ''){
                this.searchText = ''
            } else {
                this.updateSearch()
            }
        }
    },
    mounted(){
        this.updateSearch()
    },
    methods: {
        onClickSearch(){
            if (this.currentPage > 0){
                this.currentPage = 0
            } else {
                this.updateSearch()
            }
        },
        onClickAddToPath(content){
            this.$refs.modalPaths.open(content, this.userId)            
        },
        onClickPlayContent(content, component){
            if (content.type == 'PA'){
                this.$refs.modalPathDetails.open(content, this.userId, this.sessionId )
            } else {
                if (contentWindow !== null && !contentWindow.closed) {
                    contentWindow.close();
                }

                if (!component){
                    component = 0
                }

                let height = screen.height - 100;
                let width = screen.width - 20;
                let url = "/structure/ContentPlayAction?traking=0&contentId=" + content.content_id + "&component=" + component
                
                if (this.userId){
                    url += "&userId=" + this.userId
                }
                if (this.sessionId && this.sessionId != 'undefined'){
                    url += "&sessionId=" + this.sessionId
                }
                
                contentWindow = window.open(url, 
                    "", 
                    "top=0, left=0, width=" + width + ", height=" + height + ", status=no, menubar=no, toolbar=no scrollbars=no");
            }
        },
        onClickAddContentToSession(content){
            this.isLoading = true
            axios.post('/structure/session/UserSessionAction-addContentToSession', {
                sessionId: this.sessionId,
                contentId: content.content_id
            })
                .then((response) => {
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }
                    
                    if (this.contentInSession.indexOf(content.content_id) == -1){
                        this.exerciseCount ++;
                        if (content.tempo_stimato){
                            this.estimatedTime = parseInt(this.estimatedTime) + parseInt(content.tempo_stimato)
                        }
                        
                        this.contentInSession.push(content.content_id)
                    } else {
                        this.exerciseCount --;
                        if (content.tempo_stimato){
                            this.estimatedTime = parseInt(this.estimatedTime) - parseInt(content.tempo_stimato)
                        }
                        
                        this.contentInSession = this.contentInSession.filter((c) => c != content.content_id)
                    }
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        getFacetsGreatherThanZero(key){
            if (!this.results || 
                !this.results.facet || 
                !this.results.facet.facet_fields ||
                !this.results.facet.facet_fields[key]){
                    return {}
                }
            
            var res = {}
            for (var k in this.results.facet.facet_fields[key]){
                if (this.results.facet.facet_fields[key][k] > 0){
                    res[k] = this.results.facet.facet_fields[key][k]
                }
            }
            return res
        },
        onClickAddFacet(key, value){
            this.searchFacet[key] = value
            this.currentPage = 0
            this.updateSearch()
        },
        onClickRemoveFacet(key){
            delete this.searchFacet[key]
            
            if (key == 'activity_str'){
                delete this.searchFacet['ability_str']
                delete this.searchFacet['process_str']
            } else if (key == 'ability_str'){
                delete this.searchFacet['process_str']
            } 

            this.updateSearch();
        },
        setType(type){
            window.$('#mobile-menu-toggle').click()
            this.searchType = type
        },
        updateSearch(){
            axios.post("/structure/content/ContentFindAction-search", {
                query: this.searchText,
                facetQuery: this.searchFacet,
                currentPage: this.currentPage,
                rowPerPage: this.rowPerPage,
                sessionId: this.sessionId,
                type: this.searchType
            })
                .then((response) => {
                    this.results = response.data.data
                })
                .catch((errors) => [
                    alert(errors)
                ])
        },
        onClickRemovePath(content){
            if (!confirm("Desideri rimuovere il percorso?")){
                return
            }

            axios.get("/structure/content/ContentPathAction-remove?contentId=" + content.content_id)
                .then(() => {
                    this.updateSearch()
                })
                .catch((errors) => [
                    alert(errors)
                ])
        },
        onClickInfo(content){
            this.$refs.modalContentInfo.open(content.content_id)
        },
        onClickFavorite(content){
            content.is_favorite = !content.is_favorite
            axios.get("/structure/content/ContentFindAction-toggleFavorite?contentId=" + content.content_id)
                .then(() => {
                    if (this.searchType == 'PREFERITI'){
                        this.updateSearch()
                    }
                })
                .catch((errors) => {
                    alert(errors)
                })
        }
    }
}
</script>
<style scoped>
.margin-top{
    margin-top: 20px;
}
.assigned{
    border-color: lightgrey;
}
.not-assigned{
    
}
.assigned img {
    opacity: 0.6;
}
</style>